import React from 'react'

const AboutPage = () => (
  <div
    style={{
      margin: '0 auto',
      maxWidth: 600,
    }}
  >
    <h2>About</h2>
    <p>Hi! I'm Chris and I'm a web developer. I live in Denver and work with a variety of clients as a freelance consultant. I specialize in the front end and find myself working on a lot of Wordpress projects. I spend some of my free time learning and experimenting with technologies and languages like react, python, node, bash, and gatsby.js.</p>
    <p>When I'm not doing dev things, I enjoy playing guitar, playing video games, reading, riding my bicycle, and taking in the outdoors. I also really enjoy craft beer and live music. And frisbee golf.</p>
    <p>If you need a new website or need to redesign an old one, get in touch with me. I'm also available for various maintenance work as well as web emergencies.</p>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js